import React, { useState } from "react";
import { toast } from "react-toastify";

import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import InputTextarea from "../../../components/InputTextarea";

import api from "../../../services/api";
import { renderError } from "../../../helpers/errors";

/**
 * Busca pontual por chave: a nota que chegou por e-mail, ou que já tinha sido
 * baixada em outro sistema e por isso não entra no fluxo automático.
 */
export const ModalDfeKeys = ({ show, close, onRequested }) => {
    const [keys, setKeys] = useState('');
    const [saving, setSaving] = useState(false);

    const parsed = keys
        .split(/[\s,;]+/)
        .map(key => key.replace(/\D/g, ''))
        .filter(key => key.length === 44);

    const request = () => {
        setSaving(true);

        api.post('/dfe-invoice/sync-keys', { keys: parsed }).then(res => {
            toast.success(res.data.message ?? 'Busca solicitada');
            setKeys('');
            onRequested();
            close();
        }).catch(renderError).then(() => setSaving(false));
    };

    return (
        <Modal
            title={`Buscar nota por chave de acesso`}
            show={show}
            close={close}
            footer={
                <>
                    <Button type={`secondary`} size={`small`} text={`Cancelar`} action={close} />
                    <Button
                        type={`primary`}
                        size={`small`}
                        text={`Buscar`}
                        loading={saving}
                        disabled={parsed.length === 0}
                        action={request}
                    />
                </>
            }
        >
            <div className="section">
                <InputTextarea
                    label={`Chaves de acesso`}
                    value={keys}
                    change={setKeys}
                    rows={5}
                />
                <p className={`dfe-filter-hint`}>
                    Uma chave por linha, até 18 por vez. {parsed.length > 0 && `${parsed.length} chave(s) válida(s).`}
                    {' '}O provedor responde em instantes — a nota aparece na lista assim que chegar.
                </p>
            </div>
        </Modal>
    );
};

export default ModalDfeKeys;
